var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 214,
    viewBox: "0 0 214 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 0.459961C48.16 0.459961 0.459961 48.16 0.459961 107C0.459961 165.84 48.16 213.54 107 213.54C165.84 213.54 213.54 165.84 213.54 107C213.54 48.16 165.84 0.459961 107 0.459961ZM107 161.15C94.52 161.15 84.41 151.04 84.41 138.56C84.41 126.08 94.52 115.97 107 115.97C119.48 115.97 129.59 126.08 129.59 138.56C129.59 151.03 119.48 161.15 107 161.15ZM107 98.03C94.52 98.03 84.41 87.92 84.41 75.44C84.41 62.96 94.52 52.85 107 52.85C119.48 52.85 129.59 62.96 129.59 75.44C129.59 87.92 119.48 98.03 107 98.03Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlack);
export default __webpack_public_path__ + "static/media/icon-black.652cf372da2000fcc4a4f2384914a71d.svg";
export { ForwardRef as ReactComponent };